import React, {lazy, useEffect, useState} from 'react'
import {useAppSelector} from "@App/hooks/hooks";
import {HeaderTypes} from "@Src/types/api-response-interface";
import {getDataFromLocalStorageWithExpiry, isMobile, setDataOnLocalStorageWithExpiry} from "@Src/utils/globalUtilities";
import { LocalStorageDataModel } from '@Constants/local-storage-data-model';
import { Dialog } from 'primereact/dialog';
import './main-header/web-header.scss';

 const MobileHeader  = lazy(() =>
	import('@Features/header/mobile-header/mobile-header')
		.then(({ MobileHeader  }) => ({ default:MobileHeader   })),
);
 const WebHeader  = lazy(() =>
	import('@Src/features/header/main-header/web-header')
		.then(({ WebHeader  }) => ({ default:WebHeader   })),
);
const PaymentHeader  = lazy(() =>
	import('@Features/header/payment-header/payment-header')
		.then(({ PaymentHeader  }) => ({ default:PaymentHeader   })),
);
const PaymentHeaderInvoice  = lazy(() =>
	import('@Features/header/payment-header/payment-header-invoice')
		.then(({ PaymentHeaderInvoice  }) => ({ default:PaymentHeaderInvoice   })),
);
export  const  HeaderIndex = () => {

	const globalStore = useAppSelector(state => state.global);
	const [visibleFestivalDeal, setvisibleFestivalDeal] = useState<boolean>(false);

	function onCloseSaleCouponPopup() {
		setDataOnLocalStorageWithExpiry(LocalStorageDataModel.FESTIVAL_DEAL, true, 4 * 60 * 60 * 1000);
		setvisibleFestivalDeal(false)
	}
	useEffect(() => {
		showSaleCouponPopup()
	}, [])

	const redirectToBookstore = () => {
		onCloseSaleCouponPopup()
		window.open(`/bookstore`, "_self")
	}
	const showSaleCouponPopup = () => {
		let popUpShow = getDataFromLocalStorageWithExpiry(LocalStorageDataModel.FESTIVAL_DEAL);
		if (!popUpShow) {
			setvisibleFestivalDeal(true)
		}
	}


	return (
		<>
			<React.Suspense>
				{
					globalStore.activeHeader == HeaderTypes.MAIN_HEADER &&
					(isMobile() ? <MobileHeader/> : <WebHeader/>)
				}
				{
					globalStore.activeHeader == HeaderTypes.PAYMENT_HEADER &&
					<PaymentHeader/>
				}
				{
					globalStore.activeHeader == HeaderTypes.PAYMENT_HEADER_INVOICE &&
					<PaymentHeaderInvoice/>
				}
			</React.Suspense>
			{/* <Dialog className='sm-dialog front_dialog_1' header="" visible={visibleFestivalDeal} onHide={() => { onCloseSaleCouponPopup(); }}>
				<div className='mes_home_1'>
					<h2 className='mes_title_1'> Festival of Deals is Live! </h2>
					<div className='text-p1'> Up to 30% OFF* + Extra 10% OFF Sitewide <br></br>
						Use Code: FESTIVE25 <br></br>
						<span className='text-highlight'> Limited Time Offer </span> <br></br>
						<span className='text-highlight'> *T&Cs Apply</span>
					</div>
					<div className='flex mes_footer'>
						<a href='javascript:void(0)' className='button-primary flex-auto' onClick={() => onCloseSaleCouponPopup()} > Skip </a>
						<a href='javascript:void(0)' className='button-primary active flex-auto' onClick={() => redirectToBookstore()}> Shop Now </a>
					</div>
				</div>
			</Dialog> */}
		</>
	)
}